import ToolbarButton from './ToolbarButton'

export default ToolbarButton
